// Accès API partagé : jeton de session (Bearer) + jetons d'accès par commande.
// En production (npm run build) les requêtes partent en relatif sur le même
// domaine — nginx redirige /api, /socket.io et /uploads vers Node.
// En dev, pointe sur le backend local (surcharge possible via REACT_APP_API_URL).
export const API_URL = process.env.REACT_APP_API_URL
  ?? (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

// Jeton de session de l'utilisateur connecté (stocké dans localStorage "user")
export const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')?.token || null;
  } catch {
    return null;
  }
};

// En-têtes d'authentification à fusionner dans les options fetch
export const authHeaders = (extra = {}) => {
  const token = getToken();
  return { ...extra, ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};

// Jeton d'accès d'une commande invité : renvoyé par /api/create_order,
// conservé dans orderData.orderToken et dans la map "orderTokens"
export const storeOrderToken = (orderId, token) => {
  if (!orderId || !token) return;
  const map = JSON.parse(localStorage.getItem('orderTokens') || '{}');
  map[orderId] = token;
  localStorage.setItem('orderTokens', JSON.stringify(map));
};

export const orderTokenFor = (orderId, orderData) => {
  if (orderData?.orderToken) return orderData.orderToken;
  try {
    return JSON.parse(localStorage.getItem('orderTokens') || '{}')[orderId] || null;
  } catch {
    return null;
  }
};
